import { usePreviousTimeFrame } from "@/hooks/usePreviousTimeFrame";
import { DateRangeValue, startOfToday, endOfToday } from "@/utils/dateUtils";
import { getLocalStorageItem } from "@/utils/localStorageUtils";
import { ProfitOverview } from "@boxem/core-api-schema";
import { createContext, useCallback, useContext, useState } from "react";



interface ProfitOverviewState {
  profitOverview: ProfitOverview | null;
  isLoading: boolean;
  currentPeriod: DateRangeValue;
  previousPeriod: { from: Date; to: Date };
  showPreviousPeriod: boolean;
  setShowPreviousPeriod: (show: boolean) => void;
  setCurrentPeriod: (period: DateRangeValue) => void;
  fetchProfitOverviewData: () => Promise<void>;
}

const ProfitOverviewContext = createContext<ProfitOverviewState | undefined>(undefined);

export const useProfitOverview = () => {
  const context = useContext(ProfitOverviewContext);
  if (context === undefined) {
    throw new Error('useProfitOverview must be used within a ProfitOverviewProvider');
  }
  return context;
};

export const ProfitOverviewProvider = ({ children }) => {
  const [profitOverview, setProfitOverview] = useState<ProfitOverview | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showPreviousPeriod, setShowPreviousPeriod] = useState<boolean>(true);
  const [currentPeriod, setCurrentPeriod] = useState<DateRangeValue>(getLocalStorageItem('profitOverviewCurrentPeriod', {
    from: startOfToday.startOf('month').startOf('day').toDate(),
    to: endOfToday.toDate(),
    label: 'This month'
  }));

  const previousPeriod = usePreviousTimeFrame(currentPeriod);

  const fetchProfitOverviewData = useCallback(async () => {
    setIsLoading(true);
    try {
      /* const response = await getProfitAndLossComparison({
        firstInterval: previousPeriod,
        secondInterval: currentPeriod
      });
      setProfitOverview(response.data); */
    } catch (error) {
      console.error("Error fetching profit overview data:", error);
    } finally {
      setIsLoading(false);
    }
  }, [currentPeriod, previousPeriod]);


  return (
    <ProfitOverviewContext.Provider value={{
      profitOverview,
      isLoading,
      currentPeriod,
      previousPeriod,
      showPreviousPeriod,
      setCurrentPeriod,
      setShowPreviousPeriod,
      fetchProfitOverviewData
    }}>
      {children}
    </ProfitOverviewContext.Provider>
  );
}
